export * from './lib/UiLandingProductCardBioderma';
